import React from "react";
import { Box, Typography } from "@mui/material";
import "./IconMessage.css";

interface IconMessageProps {
  icon: string;
  message: string;
  boldText?: string;
  bordered?: boolean;
}

const IconMessage: React.FC<IconMessageProps> = ({
  icon,
  message,
  boldText,
  bordered = true,
}) => {
  return (
    <Box className={`info-card ${!bordered ? "borderless" : ""}`}>
      <img src={icon} alt="" />
      <Typography variant="body2" className="info-card-text" mt={3}>
        {message}{" "}
        {boldText && <strong>{boldText}</strong>}
      </Typography>
    </Box>
  );
};

export default IconMessage;